export default "__VITE_ASSET__C4svQt5Y__"